import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-063b3f68")

_pushScopeId("data-v-063b3f68")
const _hoisted_1 = { class: "h4 m0" }
const _hoisted_2 = { class: "funteamclues-log__item-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.log.length)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: ["funteamclues-log__toggle bold", { 'funteamclues-log__toggle--open': _ctx.logOpen }],
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.logOpen = !_ctx.logOpen))
        }, _toDisplayString(_ctx.logOpen ? `${_ctx.$t('common.close')} ${_ctx.$t('misc.gameLog')}` : _ctx.$t('misc.gameLog')), 3))
      : _createCommentVNode("", true),
    (_ctx.log.length)
      ? (_openBlock(), _createBlock("div", {
          key: 1,
          class: ["funteamclues-log", { 'funteamclues-log--open': _ctx.logOpen }]
        }, [
          _createVNode("h4", _hoisted_1, _toDisplayString(_ctx.$t('misc.gameLog')), 1),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.log, (item, index) => {
            return (_openBlock(), _createBlock("div", {
              key: `${item.translation}_${item.data.player}_${index}`,
              class: ["funteamclues-log__item mt1", {
        red: item.data.team === 'RED',
        blue: item.data.team === 'BLUE'
      }]
            }, [
              _createVNode("div", _hoisted_2, [
                _createVNode("span", {
                  class: ["funteamclues-log__item-background mt1", {
            red: item.data.team === 'RED',
            blue: item.data.team === 'BLUE'
          }]
                }, _toDisplayString(item.data.player), 3),
                _createTextVNode(" " + _toDisplayString(_ctx.$t(item.translation)) + " ", 1),
                _createVNode("span", {
                  class: ["funteamclues-log__item-background mt1", {
            red: item.data.wordBelongsTo === 'RED',
            blue: item.data.wordBelongsTo === 'BLUE'
          }]
                }, _toDisplayString(item.data.value), 3)
              ]),
              (item.data.team === item.data.wordBelongsTo)
                ? (_openBlock(), _createBlock("img", {
                    key: 0,
                    class: "funteamclues-log__item-checkmark",
                    src: require(`@/assets/images/check-circle.svg`),
                    alt: "checkmark"
                  }, null, 8, ["src"]))
                : _createCommentVNode("", true)
            ], 2))
          }), 128))
        ], 2))
      : _createCommentVNode("", true)
  ], 64))
})